import RecordBase from './Base';
import { useTranslation } from 'react-i18next';
import dig from 'object-dig';

export default class PartnerRecord extends RecordBase {

  static defaultAttributes = {
    name:                      '',
    code:                      '',
    doctor:                    true,
    api_token:                 '',
    created_at:                '',
    updated_at:                '',
    type:                      '',
    promo:                     '',
    supplier:                  '',
    corporation:               null,
  };

  static _attributeNames = null;

  static get attributeNames(){
    const { t } = useTranslation();
    const trAttr = (attr) => t(`partner.attributes.${attr}`);
    if(!this._attributeNames){
      this._attributeNames = {
        name:        trAttr('name'),
        code:        trAttr('code'),
        doctor:      trAttr('doctor'),
        api_token:   trAttr('api_token'),
        type:        trAttr('type'),
        created_at:  trAttr('created_at'),
        updated_at:  trAttr('updated_at'),
        promo:       trAttr('promo'),
        supplier:    trAttr('supplier'),
        corporation: trAttr('corporation')
      };
    }

    return this._attributeNames;
  }

  toParams(attrs={}){
    const {
      name,
      code,
      doctor,
      api_token,
      type,
      created_at,
      updated_at,
      promo,
      supplier,
      corporation
    } = this.toObject();

    return {
      data:{
        attributes:{
          name,
          code,
          doctor,
          api_token,
          type,
          created_at,
          updated_at,
          promo,
          supplier,
          corporation_id: dig(corporation, 'id'),
          ...attrs
        }
      }
    };
  }
}
